import type {CommonProps} from './types';

const ReturnWindow = ({
  color = 'currentColor',
  size = 12,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 14 14"
    {...rest}
  >
    <g
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path
        d="M2.23 4.81v-3.5A.96.96 0 013.26.44h9.28a.96.96 0 011.03.87v6.13a.96.96 0 01-1.03.87h-2.48M2.23 3.06h11.33"
        strokeWidth=".874995"
      />
      <path
        d="M.44 12.86a.77.77 0 00.82.7H7.5a.77.77 0 00.82-.7v-5.6a.77.77 0 00-.82-.7H1.26a.77.77 0 00-.82.7z"
        strokeWidth=".874995"
      />
      <path
        d="M10.97 13.56c.66 0 1.05-.73 1.05-1.31v-2.19"
        strokeWidth=".874995"
      />
      <path d="M13.56 11.46l-1.58-1.4-1.59 1.4" strokeWidth=".874995" />
    </g>
  </svg>
);

export default ReturnWindow;
